import {
  Tooltip as TooltipPrimitive,
  TooltipPopupProps,
  TooltipPositionerProps,
  TooltipProviderProps,
  TooltipRootProps,
  TooltipTriggerProps as TooltipPrimitiveTriggerProps,
} from "@base-ui/react/tooltip"

import { cn } from "#Utils/cn"

type TooltipProps = {
  delayDuration?: number
} & Pick<TooltipProviderProps, "closeDelay"> &
  TooltipRootProps

const Tooltip = ({ delayDuration = 200, closeDelay, children, ...props }: TooltipProps) => {
  return (
    <TooltipPrimitive.Provider delay={delayDuration} closeDelay={closeDelay}>
      <TooltipPrimitive.Root {...props}>{children}</TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}

type TooltipTriggerProps = {
  children?: TooltipPrimitiveTriggerProps["render"]
} & Omit<TooltipPrimitiveTriggerProps, "render">

export const Trigger = ({ children, ...props }: TooltipTriggerProps) => {
  return <TooltipPrimitive.Trigger {...props} render={children} />
}

type TooltipContentProps = { disabled?: boolean } & TooltipPositionerProps &
  Pick<TooltipPopupProps, "children" | "className">

export const Content = ({
  side,
  disabled = false,
  children,
  className,
  ...props
}: TooltipContentProps) => {
  if (disabled) return null

  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Positioner
        sideOffset={5}
        side={side || "top"}
        collisionPadding={6}
        className="z-9999"
        {...props}
      >
        <TooltipPrimitive.Popup
          role="tooltip"
          className={cn(
            "bg-surface-default text-content-default font-normal text-ms rounded-md ring-1 ring-black/10 dark:ring-white/15 shadow-md px-2 py-1 max-w-80 break-words ignore-on-outside-callback",
            className,
          )}
        >
          {children}
        </TooltipPrimitive.Popup>
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  )
}

Tooltip.Trigger = Trigger
Tooltip.Content = Content

export type { TooltipContentProps, TooltipProps, TooltipTriggerProps }

export default Tooltip
